<template>
  <div class="imgview-wrapper">
    <div class="img">
      <img :src="imgUrl">
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageView',
  props: ['popInKr', 'imgUrl'],
  data () {
    return {

    }
  },
  mounted () {

  },
  methods: {

  }
}
</script>

<style scoped>
  .imgview-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    background-color: rgba(0,0,0,0.6);
  }
  .imgview-wrapper .img {
    width: 100%;
    height: 100%;
  }
  .imgview-wrapper .img img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
</style>